import { useLegacyListBlocks } from 'api/blocksApi';
import { PAGE_SIZE, SearchCategories } from 'components/mediaLibrary/constants';

/** Query params of the classic block search: one search term limited to a category, plus the "Show archive" toggle. */
export default function useLegacyBlockParams(page: number, search: string, searchTerm: string, showArchived: boolean, disabled: boolean = false) {
  const getSearchTerm = (value: string, selected: SearchCategories): string | null =>
    value === SearchCategories.All || value === selected ? searchTerm! : null;

  return useLegacyListBlocks(
    page,
    PAGE_SIZE,
    getSearchTerm(search, SearchCategories.Names)!,
    getSearchTerm(search, SearchCategories.Manuscript)!,
    getSearchTerm(search, SearchCategories.Tags)!,
    showArchived,
    getSearchTerm(search, SearchCategories.Description)!,
    disabled,
  );
}
